import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";
type Column<T> = {
  header: string;
  colKey?: keyof T;
  render?: (row: T, index: number) => React.ReactNode;
  className?: string;
};

type TableProps<T> = {
  headerTitle?: string | ReactNode;
  data: T[];
  columns: Column<T>[];
  rowKey?: (row: T, index: number) => string | number;
  className?: string;
};

function Table<T>({ data, columns, rowKey, headerTitle }: TableProps<T>) {
  const { t } = useTranslation();
  return (
    <>
      {headerTitle && (
        <h3 className="text-primary-text pb-2 pt-1 font-semibold">
          {headerTitle}
        </h3>
      )}
      <table className="min-w-full border-collapse overflow-auto">
        <thead className="top-0 z-10">
          <tr>
            {columns.map((col, index) => (
              <th
                key={index}
                className={`bg-white px-4 py-2 text-start text-sm font-semibold text-black ${col.className || ""}`}
              >
                {t(col.header)}
              </th>
            ))}
          </tr>
        </thead> 
        <tbody>
          {data?.map((row, rowIndex) => (
            <tr
              key={rowKey ? rowKey(row, rowIndex) : rowIndex}
              className={`rounded-lg ${rowIndex % 2 === 0 ? "bg-Gray" : "bg-white"}`}
            >
              {columns.map((col, colIndex) => {
                return (
                  <td key={colIndex} className="px-4 py-2 text-sm">
                    {col.render
                      ? col.render(row, rowIndex)
                      : col.colKey && row[col.colKey]
                        ? String(row[col.colKey])
                        : "---"}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

export default Table;
